import { render, staticRenderFns } from "./civilinitialization.vue?vue&type=template&id=7f5b3e3a&"
import script from "./civilinitialization.vue?vue&type=script&lang=js&"
export * from "./civilinitialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports